import React, {useEffect, useState} from "react";
import {Paper} from "@mui/material";
import {RESOLVER_GROUPS_USER_URL} from './../../../../Constants/Constants';
import AxiosInstance from './../../../../services/AxiosInstance';
import AppTableView from "../../../AppTableView";
import {USER_GROUPS_COLUMNS} from "../../../ticket/grid/GridDataConstants";
//const data = Array.from({ length: 20 }, (_, i) => `Item ${i + 1}`); // 50 sample items
const itemsPerPage = 5;

function UserGroups({editUserId, selectedUserName}) {
  const [userGroups, setUserGroups] = useState([]);

  useEffect(() => {        
    getUserGroups();
  }, []);


  const getUserGroups = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(`${RESOLVER_GROUPS_USER_URL}/${editUserId}`).then(response => setUserGroups(response.data));          
  }

  return (
    <Paper>
        <AppTableView
            rows={userGroups}
            cols={USER_GROUPS_COLUMNS}
            initialPageSize={itemsPerPage}
            idKey={"groupName"}
        />
    </Paper>
  );
};

export default UserGroups;
